export const colors = {
  white: "#fff",
  black: "#000",
  green: "#00ab00",
  darkGreen: "#233427",
};
